import { render, staticRenderFns } from "./ticket_owner_types.vue?vue&type=template&id=b1f9469c&scoped=true&"
import script from "./ticket_owner_types.vue?vue&type=script&lang=js&"
export * from "./ticket_owner_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f9469c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f9469c')) {
      api.createRecord('b1f9469c', component.options)
    } else {
      api.reload('b1f9469c', component.options)
    }
    module.hot.accept("./ticket_owner_types.vue?vue&type=template&id=b1f9469c&scoped=true&", function () {
      api.rerender('b1f9469c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/ticket_owner_types.vue"
export default component.exports